import styled from "@emotion/styled";
import { Box } from "@mui/material";

export const SplitViewContainer = styled(Box)(({ theme }) => ({
  display: "flex",
  flexDirection: "row", // Default to side-by-side layout
  height: "95vh",
  gap: "24px",
  alignContent: "start",
  [theme.breakpoints.down("xl")]: {
    flexDirection: "column", // Stack the panes vertically on small screens
    height: "auto",
  },
}));

export const LeftPane = styled(Box)(({ theme }) => ({
  flex: 2,
  overflowY: "auto",
  height: "fit-content",
  maxHeight: "100%",
  [theme.breakpoints.down("sm")]: {
    flex: "none", // Reset flex behavior on small screens
    maxHeight: "none", // Allow content to grow naturally
  },
}));

export const RightPane = styled(Box)(({ theme }) => ({
  flex: 1,
  overflowY: "auto",
  [theme.breakpoints.down("sm")]: {
    flex: "none", // Same reset for the right pane on small screens
    maxHeight: "none",
  },
}));
